import React from "react"
import { AppSidebar } from "components/app-sidebar"
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "components/ui/breadcrumb"
import { Separator } from "components/ui/separator"
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "components/ui/sidebar"
import { BreadcrumbsProvider, useBreadcrumbs } from "contexts/BreadcrumbsContext"

function HeaderBreadcrumbs() {
  const { crumbs } = useBreadcrumbs();
  return (
    <Breadcrumb>
      <BreadcrumbList>
        {crumbs.map((c, idx) => (
          <React.Fragment key={idx}>
            {idx > 0 && <BreadcrumbSeparator className="hidden md:block" />}
            <BreadcrumbItem className={idx === 0 ? "hidden md:block" : undefined}>
              {c.href ? (
                <BreadcrumbLink href={c.href}>{c.label}</BreadcrumbLink>
              ) : (
                <BreadcrumbPage>{c.label}</BreadcrumbPage>
              )}
            </BreadcrumbItem>
          </React.Fragment>
        ))}
      </BreadcrumbList>
    </Breadcrumb>
  );
}

function LayoutShell({ children }: { children: React.ReactNode }) {
  const { headerActions, rightHeaderActions } = useBreadcrumbs();
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset className="overflow-x-hidden h-screen flex flex-col">
        <header className="flex h-16 shrink-0 items-center px-4">
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <SidebarTrigger className="-ml-1 h-4 w-4" />
            <Separator
                orientation="vertical"
                className="mr-2 h-4"
              />
            <HeaderBreadcrumbs />
            {headerActions && (
              <div className="ml-2 flex items-center gap-2">
                {headerActions}
              </div>
            )}
          </div>
          {rightHeaderActions && (
            <div className="flex items-center gap-2 mr-6">
              {rightHeaderActions}
            </div>
          )}
        </header>
        <div className="flex-1 min-h-0 p-4 pt-0">
          {children}
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
}

export default function Layout({ children }: { children: React.ReactNode }) {
  return (
    <BreadcrumbsProvider>
      <LayoutShell>{children}</LayoutShell>
    </BreadcrumbsProvider>
  );
}
